/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { checkIsActive } from "../../../../_helpers";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const showAcademicNav = process.env.REACT_APP_SHOW_ACADEMIC_NAV !== "false";
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };
  return (
    <ul className={`menu-nav ${layoutProps.ulClasses}`}>
      {/* <li
        className={`menu-item ${getMenuItemActive("/manage/dashboard", false)}`}
        aria-haspopup="true"
      >
        <NavLink className="menu-link" to="/manage/dashboard">
          <span className="svg-icon menu-icon">
            <span className="material-icons">dashboard</span>
          </span>
          <span className="menu-text">Dashboard</span>
        </NavLink>
      </li> */}
      <li
        className={`menu-item ${getMenuItemActive("/manage/students", false)}`}
        aria-haspopup="true"
      >
        <NavLink className="menu-link" to="/manage/students">
          <span className="svg-icon menu-icon">
            <span className="material-icons">school</span>
          </span>
          <span className="menu-text">Students</span>
        </NavLink>
      </li>
      <li
        className={`menu-item ${getMenuItemActive("/manage/onboarding", false)}`}
        aria-haspopup="true"
      >
        <NavLink className="menu-link" to="/manage/onboarding">
          <span className="svg-icon menu-icon">
            <span className="material-icons">fact_check</span>
          </span>
          <span className="menu-text">Onboarding</span>
        </NavLink>
      </li>
      {showAcademicNav && (
        <li
          className={`menu-item ${getMenuItemActive(
            "/manage/courses/programs",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/manage/courses/programs">
            <span className="svg-icon menu-icon">
              <span className="material-icons">view_module</span>
            </span>
            <span className="menu-text">Programs</span>
          </NavLink>
        </li>
      )}
      {showAcademicNav && (
        <li
          className={`menu-item ${getMenuItemActive(
            "/manage/courses/courses",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/manage/courses/courses">
            <span className="svg-icon menu-icon">
              <span className="material-icons">menu_book</span>
            </span>
            <span className="menu-text">Courses</span>
          </NavLink>
        </li>
      )}
      {showAcademicNav && (
        <li
          className={`menu-item ${getMenuItemActive(
            "/manage/courses/categories",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/manage/courses/categories">
            <span className="svg-icon menu-icon">
              <span className="material-icons">category</span>
            </span>
            <span className="menu-text">Categories</span>
          </NavLink>
        </li>
      )}
      <li
        className={`menu-item ${getMenuItemActive(
          "/manage/enrolments",
          false
        )}`}
        aria-haspopup="true"
      >
        <NavLink className="menu-link" to="/manage/enrolments">
          <span className="svg-icon menu-icon">
            <span className="material-icons">groups</span>
          </span>
          <span className="menu-text">Enrolments</span>
        </NavLink>
      </li>
      <li
          className={`menu-item ${getMenuItemActive(
            "/manage/subscriptions",
            false
          )}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/manage/subscriptions">
            <span className="svg-icon menu-icon">
              <span className="material-icons">card_membership</span>
            </span>
            <span className="menu-text">Subscriptions</span>
          </NavLink>
        </li>
      <li
        className={`menu-item ${getMenuItemActive(
          "/manage/instalment-payments",
          false
        )}`}
        aria-haspopup="true"
      >
        <NavLink className="menu-link" to="/manage/instalment-payments">
          <span className="svg-icon menu-icon">
            <span className="material-icons">payments</span>
          </span>
          <span className="menu-text">Installments</span>
        </NavLink>
      </li>
      <li
        className={`menu-item ${getMenuItemActive("/manage/cohorts", false)}`}
        aria-haspopup="true"
      >
        <NavLink className="menu-link" to="/manage/cohorts">
          <span className="svg-icon menu-icon">
            <span className="material-icons">tune</span>
          </span>
          <span className="menu-text">Cohorts</span>
        </NavLink>
      </li>
      {/* <li
        className={`menu-item ${getMenuItemActive("/manage/profile", false)}`}
        aria-haspopup="true"
      >
        <NavLink className="menu-link" to="/manage/profile">
          <span className="svg-icon menu-icon">
            <span className="material-icons">account_circle</span>
          </span>
          <span className="menu-text">Profile</span>
        </NavLink>
      </li> */}
      <li
        className={`menu-item ${getMenuItemActive("/manage/youth-emails", false)}`}
        aria-haspopup="true"
      >
        <NavLink className="menu-link" to="/manage/youth-emails">
          <span className="svg-icon menu-icon">
            <span className="material-icons">mail</span>
          </span>
          <span className="menu-text">Youth Emails</span>
        </NavLink>
      </li>
      <li
        className={`menu-item ${getMenuItemActive("/manage/upload", false)}`}
        aria-haspopup="true"
      >
        <NavLink className="menu-link" to="/manage/upload">
          <span className="svg-icon menu-icon">
            <span className="material-icons">tune</span>
          </span>
          <span className="menu-text">Upload</span>
        </NavLink>
      </li>
      <li
        className={`menu-item ${getMenuItemActive("/manage/settings", false)}`}
        aria-haspopup="true"
      >
        <NavLink className="menu-link" to="/manage/settings">
          <span className="svg-icon menu-icon">
            <span className="material-icons">tune</span>
          </span>
          <span className="menu-text">Settings</span>
        </NavLink>
      </li>
    </ul>
  );
}
